import { render, staticRenderFns } from "./NoMortgagePage.vue?vue&type=template&id=2fa09200&scoped=true"
import script from "./NoMortgagePage.vue?vue&type=script&lang=js"
export * from "./NoMortgagePage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgagePage.vue?vue&type=style&index=0&id=2fa09200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa09200",
  null
  
)

export default component.exports